import React from 'react';

const CommonGroupInput = ({ 
    name,
    minValue = 0,
    label,
    groupLabel='',
    value,
    onChange,
    type = 'text',
    placeholder = '',
    required = false,
    disabled = false,
    errors,
    className = 'mb-3 ',
    inputClassName = '',
    ...props
}) => {
    return (
        <div className={`${className}`}>
            {label && (
                <label className="form-label">
                    {label}
                    {required && <span className="text-danger ms-1">*</span>}
                </label>
            )}

            <div className={`input-group w-100 ${errors?.[name] ? 'is-invalid' : ''}`}>
                <input
                    type={type}
                    name={name}
                    min={minValue} 
                    value={value}
                    onChange={onChange}
                    className={`form-control ${inputClassName} ${errors?.[name] ? 'is-invalid' : ''}`}
                    placeholder={placeholder}
                    disabled={disabled}
                    {...props}
                />
                <span className="input-group-text rounded-end-pill bg-light text-muted">{groupLabel}</span>
            </div>
            {errors?.[name] && (
                <div className="invalid-feedback">
                    {Array.isArray(errors[name]) ? errors[name][0] : errors[name]}
                </div>
            )}
        </div>
    );
};

export default CommonGroupInput; 